import React, { useState, useEffect } from 'react';

const subjects = ['Math', 'Computer Science', 'Philosophy', 'History', 'Psychology', 'Astronomy', 'Media', 'Communications', 'English', 'Political Science'];
const gradYearOptions = ['First Year Student', 'Second Year Student', 'Other'];
const times = ['Weekday 2-5 pm', 'Weekday 5-7 pm', 'Weekday after 7 pm', 'Weekends', 'Other'];

export default function TutorRegisterSMC() {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    schoolEmail: '',
    subjects: [],
    time: times[0],
    ptk: '',
    comments: '',
    gradYear: '',
    requestedSubjects: ''
  });
  const [submitted, setSubmitted] = useState(false);

  // Track page view with Google Analytics
  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-CC8DD4BS2W', {
        page_path: '/tutor-register-smc',
        page_title: 'SMC PTK Tutor Registration'
      });
    }
  }, []);

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    if (name === 'subjects') {
      if (checked) {
        setForm({ ...form, subjects: [...form.subjects, value] });
      } else {
        setForm({ ...form, subjects: form.subjects.filter(s => s !== value) });
      }
    } else {
      setForm({ ...form, [name]: value });
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
      const res = await fetch(`${API_BASE_URL}/api/tutors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          ...form, 
          subjects: form.subjects,
          program: 'SMC'
        }),
      });
      if (res.ok) {
        setSubmitted(true);
      } else {
        alert('Error registering tutor. Please try again.');
      }
    } catch (err) {
      alert('Could not connect to the server.');
    }
  }

  if (submitted) {
    return (
      <div>
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Thank you for registering as a tutor!</h2>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ padding: '1rem', background: '#f7f9fb', minHeight: '100vh' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '3rem', marginBottom: '3rem' }}>
          <div style={{ background: '#fff', borderRadius: 18, maxWidth: 720, padding: '2.5rem', textAlign: 'center', fontSize: '1.05em' }}>
            <h1 style={{ fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', fontWeight: 800, marginBottom: 18, letterSpacing: 1, color: '#111' }}>SMC PTK Tutor Registration</h1>
            <p style={{ textAlign: 'center' }}>
              Please make sure your name and school email address are accurate so we can verify that you are a student at this school. We will use your gmail address to communicate with you. Note: Applications are only being accepted from the PTK honor society.
            </p>
            <form onSubmit={handleSubmit}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginBottom: '1rem' }}>
                <div style={{ flex: 1 }}>
                  <label>First Name*<br /><input name="firstName" value={form.firstName} onChange={handleChange} required /></label>
                </div>
                <div style={{ flex: 1 }}>
                  <label>Last Name*<br /><input name="lastName" value={form.lastName} onChange={handleChange} required /></label>
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Email (Gmail)*<br /><input name="email" type="email" value={form.email} onChange={handleChange} required style={{ width: '100%' }} /></label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>School Email*<br /><input name="schoolEmail" type="email" value={form.schoolEmail} onChange={handleChange} required style={{ width: '100%' }} /></label>
                <small style={{ fontSize: '1em' }}>We will use this email to verify that you are a student.</small>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Student Year*<br />
                  <select name="gradYear" value={form.gradYear} onChange={handleChange} required style={{ width: '100%' }}>
                    <option value="">Select Year</option>
                    <option value="First Year Student">First Year Student</option>
                    <option value="Second Year Student">Second Year Student</option>
                    <option value="Other">Other</option>
                  </select>
                </label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Subjects you would like to tutor<br />
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
                    {subjects.map(subject => (
                      <label key={subject} style={{ marginRight: '12px', fontSize: '0.9em' }}>
                        <input
                          type="checkbox"
                          name="subjects"
                          value={subject}
                          checked={form.subjects.includes(subject)}
                          onChange={handleChange}
                          style={{ marginRight: '4px' }}
                        /> {subject}
                      </label>
                    ))}
                  </div>
                </label>
              </div>
              <div style={{ marginBottom: 16, textAlign: 'left', fontSize: '0.95em', color: '#333' }}>
                <div style={{ marginBottom: 6, fontWeight: 500 }}>
                  Add any classes below that you would like to tutor that are not an option in the list above. Leave the box blank if you do not have any subjects to add.
                </div>
                <textarea
                  name="requestedSubjects"
                  value={form.requestedSubjects}
                  onChange={handleChange}
                  rows={2}
                  style={{ width: '100%', fontSize: '1em', borderRadius: 6, border: '1px solid #ccc', padding: 8 }}
                  placeholder="New subjects (optional)"
                />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>What time will you typically like to tutor?<br />
                  <select name="time" value={form.time} onChange={handleChange} style={{ width: '100%' }}>
                    {times.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Are you a member of SMC PTK Honor Society?*<br />
                  <label><input type="radio" name="ptk" value="Yes" checked={form.ptk === 'Yes'} onChange={handleChange} required /> Yes</label>{' '}
                  <label><input type="radio" name="ptk" value="No" checked={form.ptk === 'No'} onChange={handleChange} required /> No</label>
                </label>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label>Any comments or questions?<br />
                  <textarea name="comments" value={form.comments} onChange={handleChange} rows={3} style={{ width: '100%', fontSize: '1em' }} />
                </label>
              </div>
              <button type="submit" style={{ background: '#04d664', color: 'white', border: 0, borderRadius: 24, padding: '0.75rem 3rem', fontSize: '2.25rem', cursor: 'pointer' }}>Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
